/**
 * Client-side configuration for the empavision enrichments extension.
 *
 * Required env vars (REACT_APP_ prefix is required for CRA/webpack public access):
 *   REACT_APP_EMPAVISION_URL             - e.g. https://empavision.com
 *   REACT_APP_EMPAVISION_INTEGRATION_ID  - integration ID for this marketplace
 *   REACT_APP_DEV_API_SERVER_PORT        - (dev only) port of the local API server
 *
 * These are read from the *host* app's environment at the host's build time,
 * because this package is compiled as source by each marketplace's webpack.
 *
 * When EMPAVISION_URL / INTEGRATION_ID are not set, the extension runs in
 * fallback mode: `useEnrichments` returns {} unless the host opts into the
 * client-side synthesizer (see ./synthesizer.js).
 */

const empavisionUrl = process.env.REACT_APP_EMPAVISION_URL || '';
const integrationId = process.env.REACT_APP_EMPAVISION_INTEGRATION_ID || '';

/**
 * Resolves the base URL of the host marketplace's *own* API server (which
 * proxies to empavision). Mirrors the Sharetribe Web Template's util/api.js so
 * this package stays self-contained (no import from host app code).
 */
export const apiBaseUrl = marketplaceRootURL => {
  const port = process.env.REACT_APP_DEV_API_SERVER_PORT;
  const useDevApiServer = process.env.NODE_ENV === 'development' && !!port;

  // In development, the dev API server runs on a different port.
  if (useDevApiServer) {
    return `http://localhost:${port}`;
  }

  // Otherwise use the given root URL, or the same origin as the frontend.
  if (marketplaceRootURL) {
    return marketplaceRootURL.replace(/\/$/, '');
  }
  return typeof window !== 'undefined' ? window.location.origin : '';
};

export const config = {
  isEnabled: Boolean(empavisionUrl && integrationId),
  empavisionUrl,
  integrationId,
};
